"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.default=function(hex){var shorthandRegex=/^#?([a-f\d])([a-f\d])([a-f\d])$/i,lhex=hex;lhex=lhex.replace(shorthandRegex,function(m,r,g,b){return r+r+g+g+b+b});var result=/^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(lhex);return result?[parseInt(result[1],16),parseInt(result[2],16),parseInt(result[3],16)]:null};


//////////////////
// WEBPACK FOOTER
// ./node_modules/form-components/lib/__utils/helpers/hexToRgb.js
// module id = 158
// module chunks = 0